export default __webpack_public_path__ + "static/media/shieldRed.4d4c8a74.svg";